<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>选题</el-breadcrumb-item>
        <el-breadcrumb-item>进度日程</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">进度日程</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="createDialog = true"
          >创建</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :model="query"
      >
        <el-form-item label="平台：">
          <div class="choose-wrap">
            <div
              class="item"
              v-for="(item,index) in platform"
              :key="index"
              @click="choosePlatform(item,index)"
              :class="{'active':platformIndex==index}"
            >{{item.name}}</div>
          </div>
        </el-form-item>
        <el-form-item
          label="账号："
          v-if="accountList.length"
        >
          <div class="choose-wrap">
            <div
              class="item"
              v-for="(item,index) in accountList"
              :key="index"
              @click="chooseAccount(item,index)"
              :class="{'active':accountIndex==index}"
            >{{item.name}}</div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="values">
        <el-calendar v-model="calendarValue">
          <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
          <template
            slot="dateCell"
            slot-scope="{date, data}"
          >
            <div class="date-cell">
              <div
                class="cell-title"
                :class="{'isSelected': data.isSelected}"
              >
                {{ data.day.split('-').slice(2).join('-') }}
              </div>
              <div class="topic-wrap">
                <div
                  class="topic-item"
                  v-for="(item,index) in formateDateCell(date,data)"
                  :key="index"
                  @click.stop="openEditDialog(item)"
                  v-show="index<4"
                >
                  <!--     -->
                  <div
                    class="point"
                    :class="{'point-other':item.status==0}"
                  ></div>
                  <div class="topic-name">{{item.writing_title}}</div>
                </div>
                <PublishPopover
                  :list="formateDateCell(date,data)"
                  :date="date"
                  v-if="formateDateCell(date,data)&&formateDateCell(date,data).length>4"
                  @edit="handleToEdit"
                />
              </div>
            </div>
          </template>
        </el-calendar>

      </div>
      <div class="footer">

      </div>
    </div>
    <ReleaseCreate
      :visible="createDialog"
      @close="createDialog=false"
      @submit="fetchList"
    />
    <ReleaseEdit
      :visible="editDialog"
      @close="editDialog=false"
      @submit="fetchList"
      :content="editContent"
    />
    <ContentRelease
      :visible="releaseDialog"
      @close="releaseDialog=false"
      @submit="fetchList"
      :content="editContent"
    />
  </div>
</template>

<script>

import { mediapublishlist, mediapublishDestroy, mediapublishlistDestroy, mediapublishstatusUpdate, mediaaccountlist } from "@/api/select";
import ReleaseCreate from "@/components/dialog/select/ReleaseCreate";
import ReleaseEdit from "@/components/dialog/select/ReleaseEdit";
import ContentRelease from "@/components/dialog/select/ContentRelease";
import PublishPopover from "@/components/card/PublishPopover.vue";
import loginVue from '../../login.vue';





export default {
  components: {
    ReleaseCreate,
    ReleaseEdit,
    ContentRelease,
    PublishPopover
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 0,
      },
      pageTotal: 10,
      results: [],
      createDialog: false,
      editDialog: false,
      releaseDialog: false,
      editContent: {},
      chooseList: [],
      publish_time: "",
      calendarValue: new Date(),
      filter: {
        status: [
          { label: "发布", value: "1" },
          { label: "未发布", value: "0" },
        ],
      },
      platform: [
        {
          name: "公众号",
          value: 2
        }, {
          name: "微博",
          value: 3
        },
        /*   {
            name: "B站",
            value: 4
          }, */
        {
          name: "知乎",
          value: 5
        }, {
          name: "小红书",
          value: 1
        },
        /*     {
             name: "抖音",
             value: 6
           }, */
      ],
      platformIndex: -1,
      accountList: [],
      accountIndex: -1,
    };
  },
  created() {
    this.fetchList()
    this.$store.dispatch('getMediaTopicList')
    this.$store.dispatch('getMediaWritingList')
    this.$store.dispatch('getMediaAccountList')
    this.$store.dispatch('getAdminList')
  },
  watch: {
    // 时间数据监听
    publish_time(value) {
      if (value) {
        this.query.start_publish_time = this.$moment(value[0]).valueOf();
        this.query.end_publish_time = this.$moment(value[1]).valueOf();
      } else {
        this.query.start_publish_time = "";
        this.query.end_publish_time = "";
        this.fetchList(true)

      }
    },
    calendarValue(value) {
      /* console.log(value.getTime(), 'value'); */
      this.fetchList()
    }

  },
  methods: {

    fetchList(isReset = false) {
      const startOfMonth = this.$moment(this.calendarValue.getTime()).startOf('month').format('x');
      const endOfMonth = this.$moment(this.calendarValue.getTime()).endOf('month').format('x');
      if (isReset) {
        this.$set(this.query, "pageIndex", 1);
      }
      const params = Object.assign({}, this.query, {
        start_writing_pre_time: startOfMonth,
        end_writing_pre_time: endOfMonth,
      })
      mediapublishlist(params).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchList();
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    handleToRemove(id) {
      this.$confirm("确定要删除此条信息吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        mediapublishDestroy({ id }).then((res) => {
          this.$nextTick(() => {
            this.fetchList();
          });
        });
      })
    },
    formatePlatform_code(val) {
      const platform_code = {
        1: "小红书",
        2: "公众号",
        3: "微博",
        /*    4: "B站", */
        5: "知乎",
        /*       6: "抖音", */

      };
      return platform_code[val] || "";
    },
    openEditDialog(row) {
      this.editDialog = true
      this.editContent = Object.assign({}, row)
    },
    openReleaseDialog(row) {
      this.releaseDialog = true
      this.editContent = Object.assign({}, row)
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    handleToDeleteAll() {
      if (this.chooseList.length == 0) {
        this.$message.error('还没有选择要删除的数据')
        return
      }
      this.$confirm("确定要删除这些信息吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = this.chooseList.map(v => { return v.id })
        mediapublishlistDestroy({ ids }).then((res) => {
          this.fetchList();
        });
      })
    },
    formateCreator(val) {
      if (this.$store.state.adminList.length) {
        if (val) {
          if (this.$store.state.adminList.findIndex((v) => { return v.id == val }) > -1) {
            return this.$store.state.adminList.find((v) => { return v.id == val }).nickname
          } else {
            return "无"
          }
        } else {
          return "无"
        }
      }
    },
    handleToRelease(row, status) {
      this.$confirm("确定要修改发布状态吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let query = {
          id: row.id,
          status: status,
        }
        mediapublishstatusUpdate(query).then((res) => {
          this.fetchList();
        });
      })
    },
    handleToOpen(url) {
      window.open(url)
    },
    formateDateCell(date, data) {
      if (this.results.length) {
        let item_time = this.$moment(date.getTime()).startOf('day').format('x')
        let arr = []
        this.results.forEach((v) => {
          if (this.$moment(v.writing_pre_pub_time).startOf('day').format('x') == item_time) {
            arr.push(v)
          }
        })
        return arr
      }

    },
    choosePlatform(item, index) {
      this.platformIndex = index
      this.accountIndex = -1
      let query = {
        isPaging: 0,
        platform_codes: item.value,
      }
      mediaaccountlist(query).then((res) => {
        this.accountList = res.list
      });
    },
    chooseAccount(item, index) {
      this.accountIndex = index
      this.query.account_id = item.id
      this.fetchList(true)
    },
    handleToEdit(item) {
      this.openEditDialog(item)
    }

  },
};
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
    .choose-wrap {
      display: flex;
      flex-wrap: wrap;
      .item {
        cursor: pointer;
        margin-right: 16px;
        text-align: justify;
        & + .item {
        }
      }
      .active {
        color: #409eff;
      }
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
.date-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  .cell-title {
    color: #333;
    font-weight: 600;
    padding: 8px;
  }
  .isSelected {
    border-radius: 50%;
    color: #fff;
    background: #409eff;
  }
  .topic-wrap {
    width: 100%;
    margin-top: 16px;
    padding: 0px 8px;

    .topic-item {
      & + .topic-item {
        margin-top: 16px;
      }
      display: flex;
      align-items: center;

      .point {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #67c23a;
        margin-right: 10px;
      }
      .point-other {
        background: #f56c6c;
      }
      .topic-name {
        width: 100%;
        font-size: 14px;
        color: #606266;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    /*     .topic-item:hover {
      background: #333;
    } */
    .more-content {
      cursor: pointer;
      margin-top: 16px;
      text-align: center;
      color: #999;
    }
  }
}
/deep/.el-calendar-day {
  height: 0px;
  overflow: hidden;
  min-height: 222px;
}
/deep/.el-calendar__title {
  font-size: 18px;
  font-weight: 600;
}
/deep/.el-calendar-table {
  th {
    text-align: center;
    background: #f2f6fc;
  }
  th:before {
    content: "周";
  }
}
</style>
